// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../revvComponents";

// Components Imports
import QuickReviewIcon from "../../QuickReview/QuickReviewIcon";
// import RecipientDocHeaderInfoButton from "./RecipientDocHeaderInfoButton";
import RecipientDocHeaderDownloadButton from "./RecipientDocHeaderDownloadButton";
import RecipientDocHeaderMoreBtn from "./RecipientDocHeaderMoreBtn";
import RecipientDocHeaderForward from "./RecipientDocHeaderForwardButton";
import EsignDocHeaderEvidenceSummary from "../../RevvEsign/EsignDocHeaderEvidenceSummary";
// Actions Imports
import { QuotationActions } from "../../../actions";

// Destructuring
const { updateToolPaneData } = QuotationActions;

// Decalarations
const SENT_FOR_FILLING = "SENT_FOR_FILLING";
const FILLER = "FILLER";
const headerButtons = [
  {
    id: "notes",
    key: "notes",
    icon: ["far", "comments-alt"],
    label: "Notes",
    className: "",
    tooltipMsg: "Leave a note",
    isLeftBorder: true,
    isRightBorder: false,
  },
  // {
  //   id: "attachments",
  //   key: "attachments",
  //   icon: ["far", "paperclip"],
  //   label: "Attachments",
  //   className: "",
  //   tooltipMsg: "Attachments in this document",
  //   isLeftBorder: false,
  //   isRightBorder: false,
  // },
  // {
  //   id: "quick_review",
  //   key: "quick-review",
  //   icon: null,
  //   label: "Metalens",
  //   className: "metalens-icon",
  //   tooltipMsg: " Use metalens to review this document",
  //   isLeftBorder: false,
  //   isRightBorder: true,
  // },
];

const headerButtonsMap = {
  SHARED_DOCUMENT: [...headerButtons],
  PERMA_SHARED_DOCUMENT: [],
};

class RecipientDocHeaderButtons extends Component {
  state = {};

  _onChangeView = newView => {
    if (this.props.view === newView && this.props.isOpen === true) {
      this.props.updateToolPaneData(false, "");
    } else {
      this.props.updateToolPaneData(true, newView);
    }
  };

  _headerBtn = (button, isMobileView) => (
    <span
      key={button.id}
      className={`recipientdocheader-button ${
        button.isLeftBorder && !isMobileView ? "" : ""
      } ${button.isRightBorder && !isMobileView ? "right-border" : ""} ${
        this.props.view === button.key ? "active" : ""
      } ${button.className} ${isMobileView ? "inside-dropdown" : ""}`}
      data-test={`recipientdocheaderbuttons-${button.id}-icon`}
      onClick={() => this._onChangeView(button.key)}
      tabIndex="0"
      onKeyDown={() => {}}
      role="button">
      {button.id === "quick_review" ? (
        <QuickReviewIcon
          active={false}
          className="recipient-side-quick-revision"
        />
      ) : (
        button.icon && (
          <FontAwesomeIcon
            icon={button.icon}
            className="recipientdocheaderbuttons-icon"
          />
        )
      )}
      {isMobileView && button.label}
    </span>
  );

  _getHeaderButtons = isMobileView => {
    let headerBtns = headerButtonsMap[this.props.documentPageType];
    if (headerBtns && isMobileView) {
      headerBtns = headerBtns.filter(btn => btn.id !== "quick_review");
    }
    return headerBtns
      ? headerBtns.map(button =>
          isMobileView ? (
            this._headerBtn(button, isMobileView)
          ) : (
            <Tooltip
              placement={isMobileView ? "left" : "bottom"}
              align={{
                offset: [0, 4],
              }}
              overlay={button.tooltipMsg}>
              {this._headerBtn(button, isMobileView)}
            </Tooltip>
          ),
        )
      : null;
  };

  render() {
    const isMobileView = window.innerWidth <= 600;
    let isDocRejectBtn = false;
    if (
      this.props.stage === "SENT" &&
      this.props.recipientType === "ACCEPTOR" &&
      !this.props.acceptingStates
    ) {
      isDocRejectBtn = true;
    }
    let isDeclinedBtnEnabled = false;

    if (
      this.props.stage === SENT_FOR_FILLING &&
      this.props.recipientType === FILLER
    ) {
      isDeclinedBtnEnabled = true;
    }
    let documentForwarding = "";
    if (this.props.documentSettings) {
      this.props.documentSettings.forEach(item => {
        if (item.name === "DOCUMENT_FORWARDING") {
          documentForwarding = item.is_enabled;
        }
      });
    }
    return (
      <div className="recipientdocheaderbuttons-container">
        {/* ------- Notes, Attachments and Metalense buttons section ------- */}
        {!this.props.isLz &&
          !isMobileView &&
          this._getHeaderButtons(isMobileView)}

        {/* ------- Download button section ------- */}
        {!isMobileView &&
          this.props.documentPageType === "SHARED_DOCUMENT" &&
          !isDocRejectBtn &&
          !isDeclinedBtnEnabled && (
            <RecipientDocHeaderDownloadButton
              data-test="recipientdocheaderdownloadbutton"
              isSharedDocument={this.props.isSharedDocument}
              sharingHash={this.props.sharingHash}
              tooltipPlacement="bottom"
            />
          )}
        {documentForwarding && this.props.docForwardingAllowed && (
          <RecipientDocHeaderForward sharingHash={this.props.sharingHash} />
        )}
        {/* ------- More button section------- */}
        {this.props.documentPageType === "SHARED_DOCUMENT" &&
          (isMobileView || isDocRejectBtn || isDeclinedBtnEnabled) && (
            <RecipientDocHeaderMoreBtn
              isSharedDocument={this.props.isSharedDocument}
              sharingHash={this.props.sharingHash}
              isMobileView={isMobileView}
              isDocRejectBtn={isDocRejectBtn}
              documentPageType={this.props.documentPageType}
              isDeclinedBtnEnabled={isDeclinedBtnEnabled}>
              {isMobileView ? this._getHeaderButtons(isMobileView) : null}
            </RecipientDocHeaderMoreBtn>
          )}
        {this.props.documentPageType === "SHARED_DOCUMENT" &&
          this.props.stage === "COMPLETED" &&
          this.props.recipientType === "SIGNER" && (
            <EsignDocHeaderEvidenceSummary
              sharingHash={this.props.sharingHash}
              signatories={this.props.signatoriesV2}
              docID={this.props.docID}
              docObjectId={this.props.docObjectId}
              docObjectIdShared={this.props.docObjectIdShared}
              isLz={this.props.isLz}
              docName={this.props.name}
              docStage={this.props.stage}
            />
          )}
        {/* ------- Revv Info button section(for desktop devices and for magic links) ------- */}
        {/* {(this.props.documentPageType === "PERMA_SHARED_DOCUMENT" ||
          this.props.documentPageType === "MASTER_SHARED_DOCUMENT" ||
          !isMobileView) && (
          <RecipientDocHeaderInfoButton
            data-test="recipientdocheaderinfobutton"
            tooltipPlacement="left"
            isMobileView={isMobileView}
            docType={this.props.documentPageType}
            sharingHash={this.props.sharingHash}
          />
        )} */}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { isOpen, page, view } = state.ToolPaneStore;
  const {
    document: {
      isLocked,
      stage,
      documentSettings,
      signatoriesV2,
      name,
      id: docID,
    } = {},
    content,
  } = state.DocumentStore;
  const { doc_object_id: docObjectId, is_lz: isLzSign } = state.RevvSignStore;
  const {
    recipientType,
    acceptingStates,
    docForwardingAllowed,
    doc_object_id: docObjectIdShared,
    is_lz: isLzShared,
  } = state.SharedDocument;
  let isLz = false;
  if (isLzSign) {
    isLz = isLzSign;
  } else if (isLzShared) {
    isLz = isLzShared;
  }
  return {
    isLocked,
    isOpen,
    page,
    view,
    content,
    stage,
    recipientType,
    acceptingStates,
    documentSettings,
    docForwardingAllowed,
    signatoriesV2,
    name,
    docID,
    docObjectId,
    docObjectIdShared,
    isLz,
  };
};

const mapDispatchToProps = {
  updateToolPaneData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RecipientDocHeaderButtons);
